import Enumerator from '../global/Enumerator';

export const noteTypes = [
  'automation',
  'comment',
  'call',
  'email',
  'signature',
  'sms',
  'video',
  'system_event'
];

export class NoteType extends Enumerator {
  static default() {
    return this.of('comment');
  }
}
NoteType.initEnum(noteTypes);

export default {
  noteTypes,
  NoteType
};
